import * as React from 'react';
import { Fragment } from 'react';
import {
  DatagridConfigurable,
  DateField,
  TextField,
  useRecordContext,
  useGetManyReference,
  Loading,
  WrapperField,
} from 'react-admin';
import { useMediaQuery, Divider, Theme, Typography, Box, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ComponentList from '../../components/PageComponents/ComponentList';
import { BulkActionButtons, ListActions, ListButtons } from '../../components/PageComponents/ComponentList';
import MobileGrid from './MobileGrid';
import { Account } from '../../models/account';
import { useState, useEffect } from 'react';
import { datagridSx } from "../../components/PageComponents/datagridSx";


const AccountList = () => (

  <>
    <Helmet>
      <title>Coinhouse Solutions - Accounts</title>
    </Helmet>
    <ComponentList title="Accounts" subtitle="Every client account, with the entities it owns." /* filters={orderFilters} */ actions={<ListActions ressource="accounts" filters={orderFilters} />}>
      <TabbedDatagrid />
    </ComponentList>
  </>
);

const orderFilters = [];

export const AccountCountProjects = () => {
  const record = useRecordContext();
  // fetch all comments related to the current record
  const { isLoading, error, total } = useGetManyReference(
    'projects',
    { 
      target: 'accountId',
      id: record.id,
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'id', order: 'DESC' }
    }
  );
  if (isLoading) { return <Loading />; }
  if (error) { return <p>ERROR</p>; }

  return <Typography variant="body2" sx={{ textAlign: 'center' }}>{total}</Typography>;
};

const TabbedDatagrid = () => {
  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <Fragment>
      <Divider />
      {isXSmall ? (
        <MobileGrid />
      ) : (
        <>
          <DatagridConfigurable
            bulkActionButtons={<BulkActionButtons ressource="accounts" />}
            rowClick="show"
            omit={[]}
            sx={datagridSx}
          >
            <TextField source="name" sortable={false} />
            <WrapperField sortable={false} label="Number of entities">
              <AccountCountProjects />
            </WrapperField>
            <DateField source="dateCreated" label="Created" locales="fr-FR" showTime />
            <ListButtons ressource="accounts" />
          </DatagridConfigurable>
        </>
      )}
    </Fragment>
  );
};

export default AccountList;